import { useState } from "react";
import ProductVariants from "./variants";
import { useNavigate } from "react-router-dom";
import { FlagRegionByIso } from "components/Function";

const ProductInfo = ({ product }) => {
    const [select, setSelect] = useState(0);
    const navigate = useNavigate();

    return (
        <div className="col-md-4">
            <span className="fs-2 mb-4">
                {product?.product_name}{" "}
                <span
                    className="btn btn-link text-hover-primary"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={"Copy"}
                    onClick={() => navigator.clipboard.writeText(product?.product_name)}
                >
                    <i className="ki-duotone ki-copy"></i>
                </span>
            </span>
            <div className="d-flex align-items-center gap-2 flex-wrap my-4">
                {product?.region?.key ? (
                    <FlagRegionByIso name={product.region.name} iso={product.region.key} />
                ) : (
                    ""
                )}
                <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={"Product Experience Points"}
                    className="badge badge-light-info rounded-pill"
                >
                    {product?.labels?.rating} / 5.0
                </span>
                <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={"Product Experience Points"}
                    className="badge badge-light-warning rounded-pill"
                >
                    <img src={require("components/assets/media/custom/cup.svg").default} className="me-1" alt="" />
                    Daily Ranking {product?.labels?.ranking}
                </span>
                {Boolean(product?.labels?.is_free_shipping) && (
                    <i
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Free Shipping"}
                        className="fas fa-shipping-fast fs-3"
                    ></i>
                )}
            </div>

            <p className="gap-2 mb-4 fs-6">
                <b>Tiktok Shop:{" "}</b>
                <span
                    role="button"
                    data-tooltip-id="my-tooltip"
                    onClick={() => navigate(`/admin/spy-advanced/shops/${product?.seller.seller_id}`)}
                >
                    <img src={require("components/assets/media/svg/social-logos/tiktok.svg").default} alt="" />{" "}
                    {product?.seller?.seller_name} <i className="fa-solid fa-angle-right"></i>
                </span>
            </p>

            <p className="mb-4 fs-6">
                <b>Price Ranger</b>: {product?.min_price} - {product?.max_price}
            </p>
            <p className="mb-4 fs-6">
                <b>Price</b>:{" "}
                <span className="text-danger">{product?.skus?.[select]?.real_price?.price_str || product?.price}</span>
            </p>
            <p className="mb-4 fs-6">
                <b>Category</b>: {product?.category}
            </p>
            <p className="mb-4 fs-6">
                <b>ID</b>: {product?.skus?.[select]?.sku_id || product?.product_id}
            </p>
            <p className="mb-4 fs-6">
                <b>Inventory</b>: {product?.total_stock_cnt}
            </p>
            <p className="mb-4 fs-6">
                <b>Main Sales Methods</b>: {product?.sales_flag?.name}
            </p>

            <ProductVariants product={product} variantSelect={select} setVariantSelect={setSelect} />

            {/* <hr /> */}

            {/* <div className="mt-4">
                            <h6>📝 Descriptions</h6>
                            <div className="description-box">
                                {product?.product_desc?.map((item, index) => {
                                    if (item.type === "text") {
                                        return <p key={index}>{item.text}</p>;
                                    }

                                    if (item.type === "ul") {
                                        return (
                                            <ul key={index}>
                                                {item.content.map((li, i) => (
                                                    <li key={i}>{li}</li>
                                                ))}
                                            </ul>
                                        );
                                    }

                                    if (item.type === "image") {
                                        return (
                                            <div
                                                key={index}
                                                style={{ marginBottom: "10px" }}
                                                className=" d-flex flex-column justify-content-center align-items-center gap-4"
                                            >
                                                {item.image?.url_list?.map((url, i) => (
                                                    <img
                                                        key={i}
                                                        src={url}
                                                        alt=""
                                                        style={{ maxWidth: "70%", marginBottom: "6px" }}
                                                    />
                                                ))}
                                            </div>
                                        );
                                    }

                                    return null;
                                })}
                            </div>
                        </div> */}
        </div>
    );
};

export default ProductInfo;
